export default "__VITE_ASSET__BAu3IczI__"